import { Component, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslatePipe } from "@ngx-translate/core";
import { KeycloakAuthService } from "@auth/services/keycloak-auth.service";
import { BackendNotAvailableService } from "../backend-not-available/backend-not-available.service";
import { ToastService } from "@ubisolutions/base";
import { LanguageSelectorComponent } from "@shared/base/components/navigation/language-selector/language-selector.component";

@Component({
    selector: "app-account-deactivated",
    imports: [
        MatButton,
        MatIconModule,
        TranslatePipe,
        LanguageSelectorComponent,
    ],
    templateUrl: "./account-deactivated.component.html",
    styleUrl: "./account-deactivated.component.scss",
})
export default class AccountDeactivatedComponent {
    private readonly authService = inject(KeycloakAuthService);
    private readonly backendService = inject(BackendNotAvailableService);
    private readonly toastService = inject(ToastService);

    refresh() {
        this.backendService.testConnection().subscribe({
            next: () => {
                location.replace("/workspace");
            },
            error: () => {
                this.toastService.warning("shared.account-deactivated.still-deactivated");
            },
        });
    }

    logout() {
        this.authService.logOut();
    }
}
